// extracted by mini-css-extract-plugin
export default {"card":"aqvsY","heading":"YMUVQ","cardFooter":"Y8n5n"};